export class PixTransaction {
  constructor (idPedidoVenda, qrCode, dataExpiracao) {
    this.idPedidoVenda = idPedidoVenda
    this.qrCode = qrCode
    this.dataExpiracao = dataExpiracao
  }
}
